import angular from 'angular';
import booksMenu from '../../menu/Menu';
import { PurchaseOrdersServiceProvider } from './PurchaseOrdersService';
import findPurchaseOrderDialogTemplate from './templates/FindPurchaseOrderDialog.template.html';
import updatePOStatusDialogTemplate from './templates/UpdatePOStatusDialog.template.html';

export default angular
  .module('csm.books.PurchaseOrders', [
    'ui.grid',
    'ui.grid.edit',
    'ui.grid.cellNav',
    'ui.grid.selection',
    'ui.bootstrap',
    booksMenu
  ])

  /*******************************************************************************
   * Purchase Order Template Paths
   *******************************************************************************/
  .service('FindPurchaseOrderDialog', FindPurchaseOrderDialogService)
  .service('UpdatePOStatusDialog', UpdatePOStatusDialogService)
  .factory('DGPurchaseOrderItem', DGPurchaseOrderItemFactory)
  .controller('poController', PurchaseOrderController)
  .provider('PurchaseOrdersService', PurchaseOrdersServiceProvider).name;

/*******************************************************************************
 * FindPurchaseOrderDialogService */
/**
 * Service: FindPurchaseOrderDialog
 *
 * Utility to show a dialog to search for Purchase Orders.
 *******************************************************************************/
/* @ngInject */ function FindPurchaseOrderDialogService(
  $uibModal,
  BooksSettings,
  uiGridConstants
) {
  /*****************************************************************************
   * Properties
   *****************************************************************************/
  /** Instance reference */ var mSelf = this;

  /*-----------------*/
  /* Persistent Data */
  /*-----------------*/
  /** Found POs */ mSelf.foundPOs = [];
  /** Saved filters */ var mSavedFilters;

  /*------------------------------------------*/
  /* Template to add ng-dblClick to each row. */
  /*------------------------------------------*/
  var dblClickTemplate =
    '\
<div ui-grid-cell\
      ng-dblclick = "grid.appScope.viewPO(row.entity)"\
      ng-repeat   = "(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name"\
      class       = "ui-grid-cell"\
</div>';

  /*-------------------*/
  /* Service functions */
  /*-------------------*/
  this.reset = reset;
  this.show = show;

  /*****************************************************************************
   * Controller
   *****************************************************************************/
  /* @ngInject */ function FindPOsController(
    $q,
    $scope,
    accountList,
    Alert,
    BooksSvc,
    BusyScreen,
    PurchaseOrdersService,
    SERVER,
    Tools
  ) {
    if (mSavedFilters) $scope.filters = mSavedFilters;
    else newFilters();

    initScope();
    $scope.accountList = accountList;

    /***************************************************************************
     * clear */
    /**
     * Reset the filters and remove any currently found purchase orders.
     ***************************************************************************/
    function clear() {
      $scope.findGridOptions.data = mSelf.foundPOs = [];
      newFilters();
      clearStartDate();
      $scope.data.entity = null;
    }

    /***************************************************************************
     * clearStartDate */
    /**
     * Reset the start date filter.
     ***************************************************************************/
    function clearStartDate() {
      $scope.filters.poStartDate = null;
    }

    /****************************************************************************
     * entityLabel */
    /**
     * Returns a string in the format 'Name (Address)' to be used as a label
     * in the typeahead results.
     *
     * @param   input    AddressEntityListItem
     * @return  string   Label text to use
     ****************************************************************************/
    function entityLabel(input) {
      if (!input) return;

      if (angular.isObject(input))
        return BooksSettings.addressEntityLabel(input);

      return input;
    }

    /***************************************************************************
     * entitySelected */
    /**
     * Pulls the entityID from the addressEntity object selected from the
     * lazyTypeahead.
     *
     * @param  value  Selected object.
     ***************************************************************************/
    function entitySelected(entity) {
      $scope.filters.entityID = entity ? entity.entity.id : NaN;
    }

    /***************************************************************************
     * initScope */
    /**
     * Initializes the scope properties.
     ***************************************************************************/
    function initScope() {
      /** Generic data object. */
      $scope.data = {};

      /*---------------*/
      /* Dataproviders */
      /*---------------*/
      $scope.statusTypes = [
        { value: 'A', display: 'ANY' },
        { value: 'O', display: 'OPEN' },
        { value: 'C', display: 'CLOSED' },
        { value: 'P', display: 'PAID' }
      ];

      /*------------------*/
      /* Find Grid Config */
      /*------------------*/
      $scope.findGridOptions = {
        enableColumnMenus: false,
        enableSorting: true,
        enableHorizontalScrollbar: uiGridConstants.scrollbars.NEVER,
        enableVerticalScrollbar: uiGridConstants.scrollbars.WHEN_NEEDED,
        enableRowHeaderSelection: false,
        enableFullRowSelection: true,
        multiSelect: false,
        onRegisterApi: function (gridApi) {
          $scope.findGridOptions.api = gridApi;
        },
        rowTemplate: dblClickTemplate,
        minRowsToShow: 5,
        maxRowsToShow: 5,
        columnDefs: [
          { field: 'status', maxWidth: 85 },
          {
            field: 'poNumber',
            displayName: 'PO Number',
            maxWidth: 130,
            cellFilter: ''
          },
          {
            field: 'entryDate',
            displayName: 'PO Date',
            maxWidth: 120,
            cellFilter: "date: 'MM/dd/yyyy'"
          },
          { field: 'entityName', displayName: 'For' },
          { field: 'memo', displayName: 'Title' },
          {
            field: 'amount',
            displayName: 'Total',
            maxWidth: 100,
            cellFilter: 'currency'
          }
        ],
        data: mSelf.foundPOs
      };

      /*-------------------------------------------*/
      /* Watch vendor property to set filter value */
      /*-------------------------------------------*/
      $scope.$watch('data.vendor', function (addressEntity) {
        $scope.filters.vendorID = angular.isObject(addressEntity)
          ? addressEntity.entity.id
          : null;
      });

      /*************************************************************************
       * Scope functions
       *************************************************************************/
      $scope.clear = clear;
      $scope.clearStartDate = clearStartDate;
      $scope.poSelected = poSelected;
      $scope.search = search;
      $scope.viewPO = viewPO;
      $scope.loadEntity = loadEntity;
      $scope.loadEntityList = loadEntityList;
      $scope.entityLabel = entityLabel;
      $scope.entitySelected = entitySelected;
      $scope.statusSelected = statusSelected;
    }

    /***************************************************************************
     * loadEntity */
    /**
     * Loads the addressEntity for the given <b>entityID</b>.
     *
     * @param  entityID  Entity ID to load.
     ***************************************************************************/
    function loadEntity(entityID) {
      if (entityID) return BooksSvc.getAddressEntityListItem(entityID);
    }

    /***************************************************************************
     * loadEntityList */
    /**
     * Loads the list of entities based on the string provided.
     ***************************************************************************/
    function loadEntityList(text) {
      if (text)
        return BooksSvc.findAddressEntities(text).then(function (resp) {
          return resp.data;
        });
    }

    /***************************************************************************
     * poSelected */
    /**
     * Returns an indication that a purchase order has been selected.
     ***************************************************************************/
    function poSelected() {
      return $scope.findGridOptions.api.selection.getSelectedCount() > 0;
    }

    /***************************************************************************
     * newFilters */
    /**
     * Reset the purchase order filters and clear any saved filters.
     ***************************************************************************/
    function newFilters() {
      $scope.filters = {
        status: 'A',
        poStartDate: Tools.lastFiscalYearStart(
          SERVER.BooksOrgInfo.fyMonth,
          SERVER.BooksOrgInfo.fyDay
        )
      };
      mSavedFilters = null;
    }

    /***************************************************************************
     * search */
    /**
     * Attempts to find purchase orders corresponding to the current filters.
     ***************************************************************************/
    function search() {
      mSavedFilters = $scope.filters;
      BusyScreen.setBusy(true);

      // Clear any selected rows so that if new results dont have that id it does not fail.
      $scope.findGridOptions.api?.selection.clearSelectedRows();

      PurchaseOrdersService.findPurchaseOrders($scope.filters)
        .then(function (resp) {
          $scope.findGridOptions.data = mSelf.foundPOs = resp;

          if (mSelf.foundPOs.length == 0)
            Alert.info(
              'No purchase orders were found',
              'No Purchase Orders Found'
            );
          else if (mSelf.foundPOs.length == 1) viewPO(mSelf.foundPOs[0]);
        })
        .catch(function (error) {
          Alert.error(
            error.parsedResponse?.message() ||
              'Failed to pull up purchase orders. Please try again.',
            'Find Purchase Orders Error'
          );
        })
        .finally(function () {
          BusyScreen.setBusy(false);
        });
    }

    /***************************************************************************
     * statusSelected */
    /**
     * Pulls the value from the statusType object selected with the drop-down.
     *
     * @param  status  Status object.
     ***************************************************************************/
    function statusSelected(status) {
      if (arguments.length > 0) $scope.filters.status = status.value;

      var match = $scope.statusTypes.filter(function (status) {
        return status.value == $scope.filters.status;
      });

      if (match.length > 0) return match[0];
    }

    /***************************************************************************
     * viewPO */
    /**
     * Resolve promise with passed purchase order object or the selected purchase
     * order
     ***************************************************************************/
    function viewPO(purchaseOrder) {
      if (!purchaseOrder)
        purchaseOrder =
          $scope.findGridOptions.api?.selection.getSelectedRows()[0];

      $scope.$close(purchaseOrder);
    }
  }

  /*****************************************************************************
   * reset */
  /**
   * Resets the filters and found purchase orders.
   *****************************************************************************/
  function reset() {
    mSavedFilters = null;
    mSelf.foundPOs = [];
  }

  /*****************************************************************************
   * show */
  /**
   * This will display a modal dialog to provide a means to search for purchase
   * orders.
   *
   * @return  Promise to listen on
   *****************************************************************************/
  function show(accountList) {
    return $uibModal.open({
      animation: true,
      backdrop: 'static',
      controller: FindPOsController,
      size: 'lg',
      resolve: {
        accountList: function () {
          return accountList;
        }
      },
      template: findPurchaseOrderDialogTemplate
    }).result;
  }
}

/*******************************************************************************
 * UpdatePOStatusDialogService */
/**
 * Service: UpdatePOStatusDialog. Utility to show a dialog for updating the
 * status of Purchase Orders.
 *******************************************************************************/
/* @ngInject */ function UpdatePOStatusDialogService($uibModal) {
  /****************************************************************************
   * show */
  /**
   * Shows a modal dialog allowing the user to update the current PO's status
   * to either Open or Closed. If Open, then may only become Closed, commit is
   * prevented. If Closed, then may only become Open, commit is prevented. If
   * setting to Closed, a date must be provided.
   *
   * @param  poID       The ID of the Purchase order to be updated.
   * @param  isClosed   Whether the current PO is Closed or not.
   * @param  closeDate  Date the PO was closed if at all.
   ****************************************************************************/
  this.show = function (poID, isClosed, closeDate) {
    return $uibModal.open({
      template: updatePOStatusDialogTemplate,
      size: 'sm',
      backdrop: 'static',
      controller: function ($scope, BooksSvc, BusyScreen, Alert) {
        $scope.data = {
          date: null,
          closed: !!isClosed,
          date: isClosed ? closeDate : null
        };

        /** Selector options. */
        $scope.options = [
          { value: false, display: 'Open' },
          { value: true, display: 'Closed' }
        ];

        /**********************************************************************
         * submit */
        /**
         * Calls the service to update the PO's status properties.
         **********************************************************************/
        $scope.submit = function () {
          if ($scope.data.date === null && $scope.data.closed) {
            Alert.error('A date must be enterred.');
            return;
          }

          BusyScreen.setBusy(true);
          BooksSvc.updatePOStatus(
            poID,
            $scope.data.closed,
            $scope.data.date
          ).then(
            function (resp) {
              BusyScreen.setBusy(false);
              $scope.$close($scope.data);
            },
            function (resp) {
              BusyScreen.setBusy(false);
              Alert.error(
                resp.parsedResponse.message() || resp.statusText,
                'Update Status Error'
              );
            }
          );
        };
      }
    }).result;
  };
}

/*******************************************************************************
 * DGPurchaseOrderItemFactory */
/**
 * Returns a constructor function to create objects to manage Purchase Order
 * Items.
 *******************************************************************************/
/* @ngInject */ function DGPurchaseOrderItemFactory(Tools) {
  /*****************************************************************************
   * Class: DGPurchaseOrderItem
   *
   * Datagrid Purchase Order Item class. This will manage a PurchaseOrderItem
   * object.
   *
   * @param  src  Source object to populate properties
   *****************************************************************************/
  function DGPurchaseOrderItem(src) {
    /** Internal Purchase Order Item. */
    var mPOItem = src || {};

    /** Instance reference. */
    var mThis = this;

    /** Accessor for source POItem. */
    mThis.getSource = function () {
      return mPOItem;
    };

    /** Account object. */
    var mAccount = !mPOItem
      ? null
      : { accountName: mPOItem.accountName, accountID: mPOItem.accountID };

    /*--------------*/
    /* DGItem Flags */
    /*--------------*/
    Object.defineProperty(mThis, 'disableDetails', {
      get: function () {
        return !mPOItem.quantity;
      }
    });
    Object.defineProperty(mThis, 'isProduct', {
      get: function () {
        return !isNaN(mPOItem.itemID) && mPOItem.itemID > 0;
      }
    });
    Object.defineProperty(mThis, 'isAccount', {
      get: function () {
        return !mThis.isProduct && (mThis.accountID > 0 || mThis.total > 0);
      }
    });
    Object.defineProperty(mThis, 'isMemo', {
      get: function () {
        return !mThis.isProduct && !mThis.isAccount;
      }
    });

    /** Accessor for the account object. */
    Object.defineProperty(this, 'account', {
      get: function () {
        return mAccount;
      },
      set: function (value) {
        mAccount = value;
        mPOItem.accountID = angular.isObject(mAccount)
          ? mAccount.accountID
          : null;
        mPOItem.accountName = angular.isObject(mAccount)
          ? mAccount.accountName
          : null;
      }
    });

    /** Accessor for the account name field. */
    Object.defineProperty(mThis, 'accountName', {
      get: function () {
        return mAccount ? mAccount.accountName : '';
      }
    });

    /** Accessor for Cost. */
    Object.defineProperty(mThis, 'cost', {
      get: function () {
        return mPOItem.cost;
      },
      set: function (value) {
        mPOItem.cost = value;
        recalculate();
      }
    });

    /** Accessor for Freight. */
    Object.defineProperty(mThis, 'freight', {
      get: function () {
        return mPOItem.freight;
      },
      set: function (value) {
        mPOItem.freight = value;
        recalculate();
      }
    });

    /** Returns an indication that the delete button should be hidden as the item cannot be removed. */
    mThis.hideDelete = function () {
      return !!mPOItem.id && !mPOItem.canDelete;
    };

    /** Accessor for the item/memo field. Setter can be text or a Product Item */
    Object.defineProperty(mThis, 'memo', {
      get: function () {
        return mPOItem.memo;
      },
      set: function (value) {
        var forProduct = angular.isObject(value);
        mPOItem.memo = forProduct ? value.name : value;
        mPOItem.itemID = forProduct ? value.id : null;

        /*-----------------------------------------------*/
        /* Update the forInventory flag on this instance */
        /*-----------------------------------------------*/
        mThis.forInventory = forProduct && value.trackInventory;

        if (forProduct) {
          mPOItem.quantity = 1;
          mPOItem.cost = value.invCost;
          mPOItem.freight = value.freight;

          if (value.trackInventory) mPOItem.account = null;
        }
      }
    });

    /** Accessor for Quantity. */
    Object.defineProperty(mThis, 'quantity', {
      get: function () {
        return mPOItem.quantity;
      },
      set: function (value) {
        mPOItem.quantity = Math.ceil(Number(value));
        recalculate();
      }
    });

    /** Item requires that an account be set. */
    Object.defineProperty(mThis, 'requireAccount', {
      get: function () {
        return (
          (mThis.isProduct || mThis.isAccount || mThis.total > 0) &&
          !mThis.forInventory
        );
      }
    });

    /** Item requires that an tax be set. Ignores inventory items, because tax is set in the Inventory Product dialog. */
    Object.defineProperty(mThis, 'requireTax', {
      get: function () {
        return mThis.isProduct && !mThis.forInventory;
      }
    });

    /** Accessor for Subtotal. */
    Object.defineProperty(mThis, 'subTotal', {
      get: function () {
        return mPOItem.subTotal;
      }
    });

    /** Accessor for Tax. */
    Object.defineProperty(mThis, 'tax', {
      get: function () {
        return mPOItem.tax;
      },
      set: function (value) {
        mPOItem.tax = value;

        mPOItem.taxRate = Tools.roundToPrecision(
          mPOItem.subTotal ? value / mPOItem.subTotal : 0,
          8
        );
        recalculate();
      }
    });

    /** Accessor for Tax Rate. */
    Object.defineProperty(mThis, 'taxRate', {
      get: function () {
        return mPOItem.taxRate;
      },
      set: function (value) {
        mPOItem.taxRate = value;
        recalculate();
      }
    });

    /** Returns taxrate in percent form (e.g. 8.75%) and sets it in decimal form (e.g. 0.0875). */
    mThis.taxRateDisplay = function (value) {
      if (arguments.length) {
        mPOItem.taxRate = value / 100;
        recalculate();
      }

      return Tools.roundToPrecision(mPOItem.taxRate * 100, 2);
    };

    /** Accessor for Total. */
    Object.defineProperty(mThis, 'total', {
      get: function () {
        return mPOItem.total;
      },
      set: function (value) {
        mPOItem.total = value;
      }
    });

    Object.defineProperty(mThis, 'amountPaid', {
      get: function () {
        return mPOItem.amountPaid;
      },
      set: function (value) {
        mPOItem.amountPaid = value;
      }
    });

    Object.defineProperty(mThis, 'amountOwed', {
      get: function () {
        return mPOItem.amountOwed;
      },
      set: function (value) {
        mPOItem.amountOwed = value;
      }
    });

    /** Accessor for Vendor information. */
    Object.defineProperty(mThis, 'vendor', {
      get: function () {
        return mPOItem.vendor;
      },
      set: function (value) {
        mPOItem.vendor = angular.isObject(value) ? value : null;
        mPOItem.vendorID = angular.isObject(value) ? value.entity.id : null;
        mPOItem.vendorName = angular.isObject(value) ? value.entity.name : null;
      }
    });

    /** Accessor for Vendor information. */
    Object.defineProperty(mThis, 'vendorName', {
      get: function () {
        return mPOItem.vendorName;
      }
    });

    /***************************************************************************
     * recalculate */
    /**
     * Update tax, subTotal, and total properties on the source item.
     ***************************************************************************/
    function recalculate() {
      /*--------------------------------------------------------*/
      /* Calculate the total only if this has a quantity, as an */
      /* item without a quantity has the total set by the user. */
      /*--------------------------------------------------------*/
      if (mPOItem.quantity > 0) {
        mPOItem.subTotal = mPOItem.quantity * mPOItem.cost;
        mPOItem.tax = Tools.roundToPrecision(
          mPOItem.subTotal * mPOItem.taxRate,
          2
        );
        mPOItem.total =
          Number(mPOItem.subTotal || 0) +
          Number(mPOItem.tax || 0) +
          Number(mPOItem.freight || 0);
      } else
        mPOItem.quantity =
          mPOItem.cost =
          mPOItem.tax =
          mPOItem.subTotal =
          mPOItem.freight =
            NaN;
    }

    recalculate();
  }

  return DGPurchaseOrderItem;
}

/*******************************************************************************
 * PurchaseOrderController */
/**
 * Main controller for the Purchase Orders app.
 *******************************************************************************/
/* @ngInject */ function PurchaseOrderController(
  $scope,
  $q,
  $timeout,
  Alert,
  DGPurchaseOrderItem,
  SERVER,
  BooksSettings,
  BooksSvc,
  BusyScreen,
  FindPurchaseOrderDialog,
  CommonUIGridTemplates,
  EntityMaker,
  Tools,
  InventoryProducts,
  UpdatePOStatusDialog,
  Session,
  PurchaseOrdersService,
  uiGridConstants
) {
  BusyScreen.setBusy(false);

  $scope.data = {};

  /** Reference to self. */
  var mThis = this;

  /*-----------*/
  /* UI Flags. */
  /*-----------*/
  var mUI_Flags = {};
  mUI_Flags.isNew = false;
  mUI_Flags.isPaid = false;
  mUI_Flags.isPartiallyPaid = false;
  mUI_Flags.isClosed = false;

  /***
   * This was added so we could consolidate the requests that fire off on init. Since the lazy-typeahead in the purchaseOrders/index.aspx expects a function to return the po items
   * I needed a work around. Adding this allows me make the getItems fn watch the length of this array and load it in when its greater than 0. So this effectively makes the Item/Memo
   * input wait for the getAccountsAndProducts to finish.
   * **/
  var mPOItems = [];

  $scope.showStatus = function () {
    return mUI_Flags.isPaid || mUI_Flags.isClosed || mUI_Flags.isPartiallyPaid;
  };

  /** PO is for review only. */
  $scope.reviewOnly = function () {
    return mUI_Flags.isPaid || mUI_Flags.isClosed;
  };

  /** PO is new. */
  $scope.newPO = function () {
    return mUI_Flags.isNew;
  };

  /*------------*/
  /* Selections */
  /*------------*/
  /** Current PO Index. */ var mCurrentIdx = -1;
  /** Current PO ID.    */ var mPOID;
  /** Next PO Number from db. */ var mNextPONumber;

  /*------------*/
  /* Poperties. */
  /*------------*/
  /** For Entity Vendor Reference. */ var mForVendorEntity = null;
  /** Entity maker active. */ var mEntityMakerActive = false;
  /** PO watcher. */ var mPOWatcher;

  /** Purchase order object. */ $scope.data.purchaseOrder = null;
  /** Authorized by. */ $scope.data.authorizedByEntity = null;
  /** Entity PO is for. */ $scope.data.forEntity = null;
  /** Requested by field. */ $scope.data.requestedByEntity = null;
  /** Vendor item is for. */ $scope.data.vendor = null;

  /*-------------*/
  /* Validators. */
  /*-------------*/
  /** Validation group for PO Item fields. */ $scope.poItemValGroup = {};
  /** Validation group for PO header fields. */ $scope.poHeaderGroup = {};

  /** Stores entity data by lazy type ahead input element ID. entityID, authorizedBy,
  and requestedBy refer to properties on the data.purchaseOrder object; vendorID
  refers to a property on a DGPurchaseOrderItem. */
  mThis.entityData = {
    ltFor: {
      modelName: 'forEntity',
      forPO: true,
      savedEntity: $scope.data.forEntity,
      property: 'entityID'
    },
    ltAuthorizedBy: {
      modelName: 'authorizedByEntity',
      forPO: true,
      savedEntity: $scope.data.authorizedByEntity,
      property: 'authorizedBy'
    },
    ltRequestedBy: {
      modelName: 'requestedByEntity',
      forPO: true,
      savedEntity: $scope.data.requestedByEntity,
      property: 'requestedBy'
    },
    ltVendor: {
      modelName: 'vendor',
      forPO: false,
      savedEntity: $scope.data.vendor,
      property: 'vendorID'
    }
  };

  /*-------------------*/
  /* Scope Properties. */
  /*-------------------*/
  /** Working purchase order item; the po item in the item input area.*/
  $scope.data.purchaseOrderItem = new DGPurchaseOrderItem();

  /** Notes entry field collapsed flag. */
  $scope.notesCollapsed = true;

  /*----------------*/
  /* Data Providers */
  /*----------------*/
  /** Accounts. */
  $scope.data.dpAccounts = [];

  /** Products. */
  $scope.data.dpProducts = [];

  /*------------*/
  /* Grid data. */
  /*------------*/
  /***************************************************************************
   * accountLabel */
  /**
   * Label function for name account name, used in typeahead results.
   *
   * @return  string  Formatted string label in the form 'Account Name (NUM)'
   ***************************************************************************/
  $scope.accountLabel = function (acct) {
    return acct ? acct.accountName + ' (' + acct.accountNumber + ')' : '';
  };

  /***************************************************************************
   * formatAcctNameLabel */
  /**
   * For formatting the typeahed ng-model result after selection in the Account
   * Name editable template in the expense grid. Returns the account name if
   * available
   *
   * @param   acct    Account object
   * @return  String  Account Name
   ***************************************************************************/
  $scope.formatAcctNameLabel = function (acct) {
    return acct ? acct.accountName : '';
  };

  /*****************************************************************************
   * vendorLabel */
  /**
   * Returns the vendor name for the passed in DGPOItem. The
   * function should be defined before being used in the ui-grid.
   *
   * @param   input    Datagrid PO Item.
   * @return  string   Label text to use
   *****************************************************************************/
  $scope.vendorLabel = function (input) {
    return input.vendorName ? input.vendorName : '';
  };

  /*-------------------------------------------------*/
  /* Editable cell template for the Account Name     */
  /* field in the POItems Grid. On edit, displays a  */
  /* typeahead to search for accounts by their name. */
  /*-------------------------------------------------*/
  var acctCellTemplate =
    '<div style="display:block; height: 100%; z-index:1;"> ' +
    '<form name="inputForm" style="display:block; height:100%;">' +
    '<input type="INPUT_TYPE" ng-class="\'colt\' + col.uid" ui-grid-edit-typeahead ng-model="row.entity.account" ' +
    ' uib-typeahead="acct as grid.appScope.accountLabel(acct) for acct in grid.appScope.data.dpAccounts | filter:{ accountName: $viewValue } | limitTo:8" ' +
    ' typeahead-input-formatter="grid.appScope.formatAcctNameLabel($model)" typeahead-select-on-blur="true" typeahead-append-to-body="true" style="display:block; height:100%;" />' +
    '</form>' +
    '</div>';

  /** Delete column definition. */
  var mDeleteCol = {
    field: 'delete',
    maxWidth: 10,
    displayName: '',
    cellTemplate: CommonUIGridTemplates.CELL_DELETE_ROW,
    appScope: $scope
  };

  /** PurchaseOrderItems data grid. */
  $scope.poItemsGrid = {
    enableCellEdit: false,
    enableCellEditOnFocus: true,
    enableColumnMenus: false,
    enableHorizontalScrollbar: uiGridConstants.scrollbars.WHEN_NEEDED,
    enableVerticalScrollbar: uiGridConstants.scrollbars.WHEN_NEEDED,
    minRowsToShow: 5,
    columnDefs: [
      {
        field: 'memo',
        displayName: 'Item/Memo',
        editableCellTemplate: CommonUIGridTemplates.CELL_DEFAULT,
        enableCellEdit: true,
        cellEditableCondition: allowEditMemo
      },
      {
        field: 'vendorName',
        displayName: 'Vendor',
        enableCellEdit: false,
        labelFunction: $scope.vendorLabel
      },
      {
        field: 'accountName',
        displayName: 'Account',
        editableCellTemplate: acctCellTemplate,
        enableCellEdit: true,
        cellEditableCondition: allowEditAccount
      },
      {
        field: 'quantity',
        displayName: 'Qty',
        editableCellTemplate: CommonUIGridTemplates.CELL_DEFAULT,
        cellFilter: 'number',
        enableCellEdit: true,
        cellEditableCondition: allowEditQty,
        maxWidth: 50
      },
      {
        field: 'cost',
        editableCellTemplate: CommonUIGridTemplates.CELL_NUMBER_INPUT,
        precision: 2,
        cellFilter: 'currency',
        enableCellEdit: true,
        cellEditableCondition: allowEditCost,
        maxWidth: 80
      },
      {
        field: 'subTotal',
        displayName: 'Subtotal',
        cellFilter: 'currency',
        maxWidth: 80
      },
      {
        field: 'tax',
        editableCellTemplate: CommonUIGridTemplates.CELL_NUMBER_INPUT,
        precision: 2,
        cellFilter: 'currency',
        enableCellEdit: true,
        cellEditableCondition: allowEditTax,
        maxWidth: 80
      },
      {
        field: 'freight',
        editableCellTemplate: CommonUIGridTemplates.CELL_NUMBER_INPUT,
        precision: 2,
        cellFilter: 'currency',
        enableCellEdit: true,
        cellEditableCondition: allowEditFreight,
        maxWidth: 80
      },
      {
        field: 'total',
        editableCellTemplate: CommonUIGridTemplates.CELL_NUMBER_INPUT,
        precision: 2,
        cellFilter: 'currency',
        enableCellEdit: true,
        cellEditableCondition: allowEditTotal,
        maxWidth: 80
      },
      {
        field: 'amountOwed',
        displayName: 'Balance',
        precision: 2,
        cellFilter: 'currency',
        enableCellEdit: false,
        maxWidth: 80
      },
      {
        field: 'amountPaid',
        displayName: 'Paid',
        precision: 2,
        cellFilter: 'currency',
        enableCellEdit: false,
        maxWidth: 80
      },
      mDeleteCol
    ],
    onRegisterApi: function (gridApi) {
      $scope.poItemsGrid.api = gridApi;
    },
    data: []
  };

  /*---------------------------------------------------------*/
  /* Allow edit conditions for the Purchase Order Items UI   */
  /* Grid. gridscope is a pass through from the poItemsGrid. */
  /*---------------------------------------------------------*/
  function allowEditAccount(gridScope) {
    return (
      !$scope.reviewOnly() &&
      !gridScope.row.entity.isMemo &&
      Tools.isNaNZero(gridScope.row.entity.getSource().inventoryProductID) &&
      !$scope.data.purchaseOrder.referenced
    );
  }
  function allowEditTotal(gridScope) {
    return !$scope.reviewOnly() && gridScope.row.entity.isAccount;
  }
  function allowEditCost(gridScope) {
    return (
      !$scope.reviewOnly() &&
      !gridScope.row.entity.isMemo &&
      !Tools.isNaNZero(gridScope.row.entity.quantity)
    );
  }
  function allowEditFreight(gridScope) {
    return (
      !$scope.reviewOnly() &&
      !gridScope.row.entity.isMemo &&
      !Tools.isNaNZero(gridScope.row.entity.quantity)
    );
  }
  function allowEditMemo(gridScope) {
    return !$scope.reviewOnly() && !gridScope.row.entity.isItem;
  }
  function allowEditQty(gridScope) {
    return !$scope.reviewOnly() && !gridScope.row.entity.isMemo;
  }
  function allowEditTax(gridScope) {
    return (
      !$scope.reviewOnly() &&
      !gridScope.row.entity.isMemo &&
      !Tools.isNaNZero(gridScope.row.entity.quantity)
    );
  }

  /****************************************************************************
   * Functions
   ****************************************************************************/
  /****************************************************************************
   * addPOItem */
  /**
   * Validates the item input fields before adding to the poItemsGrid. If this
   * is for an item, check if the item has multiple inventory configurations.
   ****************************************************************************/
  function addPOItem() {
    var dgItem = $scope.data.purchaseOrderItem;

    if (!$scope.poItemValGroup.validate()) return;

    var promise = null;

    /*----------------------------------------------------------------*/
    /* If the account is required, check to see if it is a Trust, and */
    /* if it will be overdrawn. If it is, we want to warn the user.   */
    /*----------------------------------------------------------------*/
    if (dgItem.requireAccount) {
      /*-----------------------------------------------------*/
      /* Find the account that matches the item's accountID. */
      /*-----------------------------------------------------*/
      var acct = Tools.findArrayItem(
        $scope.data.dpAccounts,
        'accountID',
        dgItem.getSource().accountID
      );

      /*------------------------------------------------------------*/
      /* Get the account balance as long as the account is a trust. */
      /*------------------------------------------------------------*/
      if (acct && acct.type == 'Trust') {
        BusyScreen.setBusy(true);
        promise = BooksSvc.getAccountBalance(dgItem.getSource().accountID).then(
          function (resp) {
            BusyScreen.setBusy(false);

            /*---------------------------------------------------*/
            /* Confirm the item total will not overdraw the      */
            /* account. If it does, display the Overdraw Dialog. */
            /*---------------------------------------------------*/
            if (resp.data - dgItem.total < 0)
              return Alert.confirm(
                'Adding this line will cause the account to be overdrawn. Would you like to continue anyway?',
                'Account Overdrawn'
              );
          }
        );
      }
    }

    $q.when(promise).then(function (resp) {
      /*--------------------------------------------*/
      /* Set the vendor property on the source item */
      /*--------------------------------------------*/
      dgItem.vendor = $scope.data.vendor;

      /*-----------------------------------------*/
      /* Non product items can be added directly */
      /*-----------------------------------------*/
      if (dgItem.isMemo || dgItem.isAccount) {
        $scope.poItemsGrid.data.push(dgItem);
        clearItemInput();
      } else if (dgItem.isProduct) {
        /*----------------------------------------------------*/
        /* Entry is an Item. Check to see if Inventory item   */
        /* and display dialogue if so; otherwise add to list. */
        /*----------------------------------------------------*/

        /**
         * The dgItem comes from the item/memo input which is loaded from
         * the mPoItems (poProducts) array. That poProducts array items only have
         * 4 values missing most of the info of a product. That is why we must look
         * for the item within the data.dpProducts array, to get the full item.
         *
         * TODO: Refactor this setup to make it so poProducts is a full item.
         *
         * ! Related Request: getAccountsAndProducts
         */
        var product = $scope.data.dpProducts
          .filter(function (prod) {
            return prod.id == dgItem.getSource().itemID;
          })
          .shift();

        /*-------------------------------------------------*/
        /* Verify the item has multiple selection options. */
        /*-------------------------------------------------*/
        InventoryProducts.verify(product).then(function (resp) {
          var invalidCount = 0;
          var poItemsToAdd = [];

          /*-----------------------------------------------------------*/
          /* If multiple options returned, map each to a DGInvoiceItem */
          /*-----------------------------------------------------------*/
          if (resp.multi) {
            resp.items.forEach(function (ppItem) {
              var item = new DGPurchaseOrderItem();
              item.memo = { name: ppItem.memo, id: ppItem.itemID };
              item.quantity = Number(ppItem.qty);
              item.cost = Number(ppItem.cost);
              item.freight = Number(ppItem.freight);
              item.getSource().itemID = Number(ppItem.itemID);
              item.getSource().inventoryProductID = Number(
                ppItem.getSource().inventoryProductID
              );
              item.taxRate = Number(ppItem.getSource().taxRate);

              /*------------------------------------------------*/
              /* Inventory items should not have an account set */
              /*------------------------------------------------*/
              item.account = null;

              /*---------------------------------------*/
              /* Set the vendorID property on the item */
              /*---------------------------------------*/
              item.vendor = dgItem.vendor;

              /*-----------------------------------------------------------------*/
              /* Since the Inventory Items dialog does not validate tax, we must */
              /* validate the tax of each item before it is added to the grid.   */
              /*-----------------------------------------------------------------*/
              if ($scope.validatePOItemTax(item)) poItemsToAdd.push(item);
              else invalidCount++;
            });
          } else {
            dgItem.getSource().inventoryProductID = resp.items.id;

            /*--------------------------------------------*/
            /* Tax is validated by the Tax Rate field's   */
            /* custom validator, so we just add the item. */
            /*--------------------------------------------*/
            $scope.poItemsGrid.data.push(dgItem);
          }

          /*---------------------------------------------------------------*/
          /* Add the items to the scope item list if there were no invalid */
          /* items found. We only clear the item input on a successfule    */
          /* add to prevent them from needing to redo all work.            */
          /*---------------------------------------------------------------*/
          if (invalidCount <= 0) {
            clearItemInput();
            $scope.poItemsGrid.data =
              $scope.poItemsGrid.data.concat(poItemsToAdd);
          }
        });
      }
    });
  }

  /***************************************************************************
   * changeStatus */
  /**
   * Call the modal dialog to change the status of the active PO.
   ***************************************************************************/
  function changeStatus() {
    UpdatePOStatusDialog.show(
      $scope.data.purchaseOrder.id,
      $scope.data.purchaseOrder.isClosed,
      $scope.data.purchaseOrder.closeDate
    ).then(function (res) {
      getPurchaseOrder($scope.data.purchaseOrder.id, 0);
    });
  }

  /***************************************************************************
   * checkItems */
  /**
   * Displays an alert if no items have been added to the PO and returns
   * false, otherwise returns true.
   *
   * @return  boolean  True if items exist, false otherwise.
   ***************************************************************************/
  function checkItems() {
    if ($scope.poItemsGrid.data.length < 1) {
      Alert.error(
        'The PO must consist of at least line 1 Item.',
        'Missing Data'
      );
      return false;
    }
    return true;
  }

  /*****************************************************************************
   * clearItemInput */
  /**
   * Resets the purchase order item for input. Default the vendor to mForVendorEntity
   * and maintain the tax percent.
   *****************************************************************************/
  function clearItemInput() {
    $scope.data.purchaseOrderItem = new DGPurchaseOrderItem();
    $scope.data.vendor = mForVendorEntity;
    $scope.data.purchaseOrderItem.taxRate = mForVendorEntity
      ? mForVendorEntity.entity.taxPercent
      : null;
  }

  /*****************************************************************************
   * clearPurchaseOrder */
  /**
   * Verifies the current purchase order can be cleared from the UI before. If
   * the current purchase order info has been modified, the user must confirm
   * cancelling the changes before the promise is resolved. If there are no
   * changes, the promise is resolved. If the user declines to confirm clearing a
   * modified purchase order, the promise is rejected.
   *****************************************************************************/
  function clearPurchaseOrder() {
    $scope.poItemValGroup.reset();

    if ($scope.data.purchaseOrder && $scope.data.purchaseOrder.modified) {
      var title = mUI_Flags.isNew
        ? 'Cancel New Purchase Order'
        : 'Cancel Changes';
      var msg = mUI_Flags.isNew
        ? 'Are you sure you want to cancel this Purchase Order?'
        : 'You have made changes to this purchase order.\nAre you sure you want to cancel these changes?';

      return Alert.confirm(msg, title).then(
        function (result) {
          return $q.resolve();
        },
        function () {
          return $q.reject();
        }
      );
    } else return $q.resolve();
  }

  /***************************************************************************
   * disableTaxInput */
  /**
   * Used for disabling the tax input field.
   ***************************************************************************/
  $scope.disableTaxInput = function () {
    return (
      (typeof $scope.data.purchaseOrderItem.item === 'object' &&
        $scope.data.purchaseOrderItem.item != null) ||
      $scope.data.purchaseOrderItem.taxRate > 0
    );
  };

  /***************************************************************************
   * disableTotal */
  /**
   * Used for disabling the total input field.
   ***************************************************************************/
  $scope.disableTotalInput = function () {
    return (
      (typeof $scope.data.purchaseOrderItem.item === 'object' &&
        $scope.data.purchaseOrderItem.item != null) ||
      $scope.data.purchaseOrderItem.quantity > 0 ||
      $scope.data.purchaseOrderItem.cost > 0
    );
  };

  /****************************************************************************
   * entityLabel */
  /**
   * Returns a string in the format 'Name (Address)' to be used as a label
   * in the typeahead results.
   *
   * @param   input    AddressEntityListItem
   * @return  string   Label text to use
   ****************************************************************************/
  $scope.entityLabel = function (input) {
    if (angular.isObject(input))
      return BooksSettings.entityAddressItemLabel(input);

    return input;
  };

  /*****************************************************************************
   * findPurchaseOrder */
  /**
   * Shows the FindPurchaseOrderDialog. When the promise resolves, the passed
   * purchase order will be loaded and the current index is updated if multiple
   * purchase orders are available.
   *****************************************************************************/
  function findPurchaseOrder() {
    FindPurchaseOrderDialog.show($scope.data.dpAccounts).then(
      function (purchaseOrder) {
        mCurrentIdx = posFound()
          ? FindPurchaseOrderDialog.foundPOs.indexOf(purchaseOrder)
          : -1;

        clearPurchaseOrder(null).then(function () {
          getPurchaseOrder(purchaseOrder.id, 0);
        });
      }
    );
  }

  /***************************************************************************
   * getEntities */
  /**
   * Returns a list of entities that match the given text.
   *
   * @param   text   Current input text
   * @return         Array of sorted corresponding matching entities
   ***************************************************************************/
  $scope.getEntities = function (text) {
    /*----------------------------------------------------*/
    /* When there is no input text, resolve with nothing, */
    /* this is called when the model is cleared and the   */
    /* lazyTypeahead is attempting to set the model       */
    /*----------------------------------------------------*/
    if (!text) return $q.resolve();

    var defer = $q.defer();
    BooksSvc.findAddressEntities(
      text,
      BooksSettings.ledgerEntityTypes(),
      true
    ).then(function (resp) {
      var entities = resp.data.sort(function (a, b) {
        return a.entity.fullName
          .toLowerCase()
          .localeCompare(b.entity.fullName.toLowerCase());
      });
      defer.resolve(entities);
    });

    return defer.promise;
  };

  /***
   * Changed this so it now waits for the mPOItems to filled. This makes it so we could consolidate the requests
   * I would've gotten rid of this but this is needed for the lazy-typeahead Item/Memo input. It expects a fn as
   * its data-provider.
   * **/
  $scope.getItems = function () {
    return $q.when(mPOItems.length > 0).then(function () {
      return mPOItems;
    });
  };

  /***************************************************************************
   * getPurchaseOrder */
  /**
   * Reads a Purchase Order from the database. Gets the current/next/previous
   * Purchase Order from the server for the current PO ID or traverses the list
   * of POs from the Find results list. Loads the new Purchase Order into the
   * UI.
   *
   * @param  id   Current Purchasr Order ID.
   * @param  dir  Direction indicator, 0=current, 1=next, -1=previous.
   * @private
   ***************************************************************************/
  function getPurchaseOrder(id, directionIndicator) {
    var endOfList = function () {
      Alert.clear();
      Alert.info(
        'There are no more purchase orders',
        'No More Purchase Orders'
      );
    };

    /*----------------------------------------------------------------*/
    /* If purchase orders have been collected from the search,        */
    /* update the index based on the direction and get the purchase   */
    /* order ID from the new item in the list and clear the directin. */
    /*----------------------------------------------------------------*/
    if (posFound()) {
      var idx = mCurrentIdx + directionIndicator;

      if (idx < 0 || idx >= FindPurchaseOrderDialog.foundPOs.length) {
        endOfList();
        return;
      }

      mCurrentIdx = idx;
      id = FindPurchaseOrderDialog.foundPOs[mCurrentIdx].id;
      directionIndicator = 0;
    } else if (directionIndicator > 0 && !id) {
      /*------------------------------------------------------*/
      /* If no purchase orders from the search, and no id was */
      /* given when the Next button was selected, do nothing. */
      /*------------------------------------------------------*/
      endOfList();
      return;
    }

    /*--------------------------------------*/
    /* Load the purchase order for the      */
    /* purchase order ID and the direction. */
    /*--------------------------------------*/
    BusyScreen.setBusy(true);
    PurchaseOrdersService.getPurchaseOrder(id, directionIndicator).then(
      function (resp) {
        if (resp != null) {
          loadPO(resp);
        } else {
          /*-----------------------------------------------*/
          /* No Purchase Order was found. Start a new      */
          /* Purchase Order if "next" and not traversing   */
          /* find results. Else, show end of list message. */
          /*-----------------------------------------------*/
          if (directionIndicator > 0 && !posFound()) startNewPO();
          else {
            BusyScreen.setBusy(false);
            endOfList();
          }
        }
      }
    );
  }

  /***************************************************************************
   * getVendors */
  /**
   * Returns a list of entities that match the given text. Entity search based
   * on Vendor type.
   *
   * @param   text   Current input text
   * @return         Array of sorted corresponding matching entities
   ***************************************************************************/
  $scope.getVendors = function (text) {
    if (!text) return $q.resolve();

    var defer = $q.defer();
    PurchaseOrdersService.findAddressVendors(text, true).then(function (resp) {
      var entities = resp.sort(function (a, b) {
        return a.entity.fullName
          .toLowerCase()
          .localeCompare(b.entity.fullName.toLowerCase());
      });
      defer.resolve(entities);
    });
    return defer.promise;
  };

  /***************************************************************************
   * handleButton */
  /**
   * Generic button handler.
   *
   * @param  event
   ***************************************************************************/
  $scope.handleButton = function ($event) {
    switch ($event.target.id) {
      case 'btnCancel':
        clearPurchaseOrder(null).then(function () {
          startNewPO();
        });
        break;
      case 'btnChange':
        changeStatus();
        break;
      case 'btnFind':
        findPurchaseOrder();
        break;
      case 'btnNext':
        clearPurchaseOrder(null).then(function () {
          getPurchaseOrder(mPOID, 1);
        });
        break;
      case 'btnPrevious':
        clearPurchaseOrder(null).then(function () {
          getPurchaseOrder(mPOID, -1);
        });
        break;
      case 'btnAddItem':
        addPOItem();
        break;
      case 'btnClearInput':
        clearItemInput();
        break;
      case 'btnPrint':
        print();
        break;
      case 'btnSave':
        savePO();
        break;
    }
  };

  /***************************************************************************
   * handleEntity */
  /**
   * Fires when any of the entity input fields loses focus. If the model is
   * not an object and is not empty, then the user has not selected an
   * existing Entity, this displays the entity maker with the user's entry.
   *
   * @param   $event   Event object
   ***************************************************************************/
  $scope.handleEntity = function ($event) {
    /** Lazy type ahead. */
    var ltID = $event.target.parentElement.id;
    var ltElem = angular.element(document.getElementById(ltID));
    var modelProp = ltElem.attr('ng-model');
    var addressEntity = $scope.$eval(modelProp);
    var restrictAllEntities =
      !!SERVER.appFlags.restrictVendors &&
      !!SERVER.appFlags.restrictIndividuals;

    /*-------------------------------------------------------------*/
    /* Check for the restrictVendors flag when selecting a vendor. */
    /* If the vendor is an object then it already exists and we    */
    /* will set the vendor, otherwise if vendors are restricted    */
    /* clear the vendor name and display the error message.        */
    /*-------------------------------------------------------------*/
    if (
      modelProp === 'data.vendor' &&
      SERVER.appFlags.restrictVendors &&
      typeof $scope.data?.vendor !== 'object'
    ) {
      $event.target.value = '';
      return Alert.info(
        'You must select an existing vendor.',
        'Purchase Orders'
      );
    }

    if (!$scope.data.purchaseOrder) return;

    /*-------------------------------------------------------------*/
    /* Clear out the entity values if this isn't an entity object. */
    /*-------------------------------------------------------------*/
    if (!addressEntity) {
      mThis.entityData[ltID].savedEntity = null;
      $scope.data.purchaseOrder[mThis.entityData[ltID].property] = null;

      if (ltID == 'ltVendor') {
        $scope.data.purchaseOrderItem.vendor = null;
        $scope.data.purchaseOrderItem.taxRate = NaN;
      }

      return;
    }

    function updateVendor() {
      /*-------------------------------------*/
      /* Sets the vendor and their tax rate, */
      /* if exists, to the Purchase Order.   */
      /*-------------------------------------*/
      /*-------------------------------------------------------------*/
      /* Guard: on cancel/decline addressEntity is still the raw     */
      /* typed string; only apply for a resolved entity object so we */
      /* don't dereference .entity on a string.                      */
      /*-------------------------------------------------------------*/
      if (!angular.isObject(addressEntity)) return;

      if (ltID == 'ltVendor') {
        $scope.data.purchaseOrderItem.vendor = addressEntity;
        $scope.data.purchaseOrderItem.taxRate = addressEntity.entity.taxPercent;
      }

      if (ltID == 'ltRequestedBy')
        $scope.data.purchaseOrderItem.requestedByEntity = addressEntity;
    }

    /*------------------------------------------*/
    /* If it is an object, set the entity info, */
    /* otherwise bring up the Entitymaker.      */
    /*------------------------------------------*/
    if (angular.isObject(addressEntity)) {
      mThis.entityData[ltID].savedEntity = addressEntity;
      $scope.data.purchaseOrder[mThis.entityData[ltID].property] =
        mThis.entityData[ltID].savedEntity.entity.id;

      updateVendor();
    } else if (!restrictAllEntities) {
      /*-------------------*/
      /* Show EntityMaker. */
      /*-------------------*/
      mEntityMakerActive = true;

      /*---------------------------------------------------------------------*/
      /* The vendor for a purchase order must be a vendor or else saving the */
      /* PO will throw an error. We are restricting the EntityMaker below    */
      /* based on the model being added. This fixes an existing bug and was  */
      /* found in testing for https://graystep.atlassian.net/browse/GPP-23   */
      /*---------------------------------------------------------------------*/
      const vendorEntityType =
        modelProp === 'data.vendor' ? SERVER.BooksDBConstants.ET_VENDOR : null;

      /*---------------------------------------------------------------------*/
      /* Build a new entity object with result from EntityMaker and use it.  */
      /* Pass in the vendorEntityType for vendors, and null for all others   */
      /* so any entity type can be created. Any other restrictions on the    */
      /* type of entity that can be made will be handled in the EntityMaker. */
      /*---------------------------------------------------------------------*/
      EntityMaker.newEntity(addressEntity, vendorEntityType)
        .then(
          function (result) {
            BusyScreen.setBusy(true);

            if (result.added)
              return BooksSvc.getAddressEntityListItem(result.entity.id).then(
                function (resp) {
                  addressEntity = resp.data;
                  addressEntity.entity.taxPercent = result.entity.taxPercent;
                  $scope.data[mThis.entityData[ltID].modelName] = resp.data;
                  $scope.data.purchaseOrder[mThis.entityData[ltID].property] =
                    resp.data.entity.id;
                }
              );
          },

          /*-----------------------------------------------------------*/
          /* User said 'No' to creating an entity or an error occured. */
          /* Keep focus on the field (intentionally locking the user   */
          /* in) until they select a valid entity, create a new one,   */
          /* or clear the field.                                       */
          /*-----------------------------------------------------------*/
          function () {
            $event.target.focus();
          }
        )
        .finally(function () {
          BusyScreen.setBusy(false);
          mEntityMakerActive = false;
          $event.target.focus();
          updateVendor();
        });
    } else {
      $event.target.value = '';
      Alert.info('You must select an existing entity.', 'Purchase Orders');
    }
  };

  /***************************************************************************
   * loadPO */
  /**
   * Load the provided PO into the scope, set the approriate grid data.
   *
   * @param poInfo
   *  - purchaseOrder
   *  - entities
   *  - vendor (only filled if for entity is a vendor)
   ***************************************************************************/
  function loadPO(poInfo) {
    /*----------------------------*/
    /* Clear the current watcher. */
    /*----------------------------*/
    if (mPOWatcher) {
      mPOWatcher();
      mPOWatcher = null;
    }

    Alert.clear();

    clearItemInput();
    $scope.notesCollapsed = true;
    $scope.data.purchaseOrder = poInfo.purchaseOrder;
    mPOID = poInfo.purchaseOrder.id || 0;

    /*-----------*/
    /* Set flags */
    /*-----------*/
    mUI_Flags.isNew = !poInfo.purchaseOrder.id;
    mUI_Flags.isClosed = $scope.data.purchaseOrder.isClosed;
    mUI_Flags.isPaid = $scope.data.purchaseOrder.isPaid;
    mUI_Flags.isPartiallyPaid = $scope.data.purchaseOrder.isPartiallyPaid;

    /*-----------------------------------------------------*/
    /* If this is a new PO we want to initially set the PO */
    /* Number to that of the next number in the database.  */
    /*-----------------------------------------------------*/
    $scope.data.purchaseOrder.poNumber = mUI_Flags.isNew
      ? mNextPONumber
      : $scope.data.purchaseOrder.poNumber;

    /*------------------------------------------*/
    /* Clear out entity data, so it can be set. */
    /*------------------------------------------*/
    $scope.data.authorizedByEntity = null;
    $scope.data.forEntity = null;
    $scope.data.requestedByEntity = null;
    $scope.data.vendor = null;

    for (var prop in mThis.entityData) {
      var config = mThis.entityData[prop];

      var entityIDForInput = poInfo.purchaseOrder[config.property];

      if (!config.forPO || !entityIDForInput) continue;

      /***
       * The way the entities object is setup is that its a hash map/dictionary
       * the index or key field is an entity id and the value is the entity info.
       *
       * So this line here selects the entity info from the entities obj by getting
       * the entity id we use for this input and indexing entities with that.
       **/
      $scope.data[config.modelName] = poInfo.entities[entityIDForInput];
    }

    if (poInfo.vendor) {
      mForVendorEntity = $scope.data.vendor = poInfo.vendor;
    }

    /*------------------------------------------*/
    /* Create Data Grid items from the POItems. */
    /*------------------------------------------*/
    $scope.poItemsGrid.data = poInfo.purchaseOrder.items.map(function (poi) {
      return new DGPurchaseOrderItem(poi);
    });

    /*----------------------------*/
    /* Set scroll to top of page. */
    /*----------------------------*/
    window.scrollTo(0, 0);

    /*---------------------------------------------------*/
    /* Add the modified property as un-enumerable so the */
    /* watch will ignore it in its checks for equality   */
    /*---------------------------------------------------*/
    Object.defineProperty($scope.data.purchaseOrder, 'modified', {
      enumerable: false,
      writable: true,
      value: false
    });

    /*---------------------------------------------------*/
    /* Start watching for changes, only setting the      */
    /* flag when the previous value has been established */
    /*---------------------------------------------------*/
    mPOWatcher = $scope.$watch(
      'data.purchaseOrder',
      function () {
        setModified(true);
      },
      true
    );

    /*-----------------------------------------*/
    /* Watch for changes in the PO Items       */
    /* list, and update the modified property. */
    /*-----------------------------------------*/
    $scope.$watchCollection(
      'poItemsGrid.data',
      function () {
        setModified(true);
      },
      true
    );

    /*--------------------------------------------------------*/
    /* Clear the modified property after the next digest      */
    /* cycle as it was set during the initialization of watch */
    /*--------------------------------------------------------*/
    $timeout(setModified);

    BusyScreen.setBusy(false);
  }

  /*****************************************************************************
   * posFound */
  /**
   * Returns an indication that there are multiple purchase orders found.
   *
   * @return  boolean indication
   *****************************************************************************/
  function posFound() {
    return FindPurchaseOrderDialog.foundPOs.length > 1;
  }

  /***************************************************************************
   * poTotal */
  /**
   * Returns the grand total of all purchase order items currently in the grid.
   *
   * @return  String  Purchase order items total.
   ***************************************************************************/
  $scope.poTotal = function () {
    return ($scope.poItemsGrid.data || []).reduce(function (sum, item) {
      return Number(item['total']) ? sum + Number(item['total']) : sum;
    }, 0);
  };

  /***************************************************************************
   * print */
  /**
   * Print the purchase order.
   *
   * @param  skipCheck  indication to skip modified warning
   ***************************************************************************/
  function print(skipCheck) {
    var doPrint = function () {
      window.open(
        Session.getSessionURL(
          '/PrintPurchaseOrderPDF.aspx?poID={0}'.format(
            $scope.data.purchaseOrder.id
          )
        ),
        '_blank'
      );
    };

    /*------------------------------------------------------------*/
    /* Check for modifications to purchase order before printing. */
    /*------------------------------------------------------------*/
    if (!skipCheck && $scope.data.purchaseOrder.modified) {
      Alert.confirm(
        'There have been changes to this purchase order. Would you like to print the unmodified version?',
        'Modified Purchase Order'
      ).then(doPrint);
    } else doPrint();
  }

  /*****************************************************************************
   * savePO */
  /**
   * Save the PO.
   *****************************************************************************/
  function savePO() {
    Alert.clear();

    if (!$scope.poHeaderGroup.validate()) return;
    /*-------------------------*/
    /* Verify there are items. */
    /*-------------------------*/ else if (checkItems()) {
      /*-----------------------------*/
      /* Perform the save operation. */
      /*-----------------------------*/
      function save() {
        BusyScreen.setBusy(true);

        $scope.data.purchaseOrder.authorizedBy = angular.isObject(
          $scope.data.authorizedByEntity
        )
          ? $scope.data.authorizedByEntity.entity.id
          : null;
        $scope.data.purchaseOrder.entityID = angular.isObject(
          $scope.data.forEntity
        )
          ? $scope.data.forEntity.entity.id
          : null;
        $scope.data.purchaseOrder.requestedBy = angular.isObject(
          $scope.data.requestedByEntity
        )
          ? $scope.data.requestedByEntity.entity.id
          : null;

        $scope.data.purchaseOrder.items = $scope.poItemsGrid.data.map(
          function (dgi) {
            let item = dgi.getSource();

            /**
             * This is here to prevent money values to go into our database with more than 2 decimal points.
             * We do not allow this anything more than 2 decimal points must be rounded.
             *
             * We only need to edit the items because the total of the purchase order will be recalculated based on the item total.
             * */
            item.amountOwed = Tools.roundToPrecision(item.amountOwed, 2);
            item.cost = Tools.roundToPrecision(item.cost, 2);
            item.subTotal = Tools.roundToPrecision(item.subTotal, 2);
            item.total = Tools.roundToPrecision(item.total, 2);

            return item;
          }
        );

        PurchaseOrdersService.savePurchaseOrder($scope.data.purchaseOrder).then(
          function (poID) {
            Alert.success('Purchase Order saved.');

            BusyScreen.setBusy(false);
            $scope.data.purchaseOrder.id = Number(poID);

            Alert.confirm(
              'Would you like to Print the Purchase Order?',
              'Purchase Order Saved!'
            )
              .then(() => print(true))
              .finally(startNewPO);
          },
          function (resp) {
            Alert.error(resp.parsedResponse.message(), 'Save Error');
            BusyScreen.setBusy(false);
          }
        );
      }

      /*---------------------------------------------------------------*/
      /* Verify the PO Number will be sequential. If not alert the     */
      /* user, and check to see if they want to save the order anyway. */
      /*---------------------------------------------------------------*/
      PurchaseOrdersService.getNextNumber().then(function (resp) {
        var nextPONumber = resp;

        /*-----------------------------------------------------------------------*/
        /* PO Number sequence will shift over if the new number is higher than   */
        /* the highest number in the database. Check to see if that is the case. */
        /*-----------------------------------------------------------------------*/
        if ($scope.data.purchaseOrder.poNumber > nextPONumber) {
          Alert.confirm(
            'The Purchase Order Number entered is not sequential. The next sequential number is ' +
              nextPONumber +
              '. If you continue, there will be a gap in your Purchase Order Registry.',
            'Purchase Order Number out of Sequence!'
          ).then(save);
        } else save();
      });
    }
  }

  /*****************************************************************************
   * setModified */
  /**
   * Set the modified property on the $scope.data.purchaseOrder. If mPOWatcher
   * has not been instantiated, then there is no watching being done, so the
   * modified property will not be updated.
   *
   * @param modified  Boolean indication that the receipt has been modified.
   *****************************************************************************/
  function setModified(modified) {
    if (!mPOWatcher) return;

    $scope.data.purchaseOrder.modified = !!modified;
  }

  /*****************************************************************************
   * status */
  /**
   * Returns the current PO status.
   *
   * @return  string  Status: Paid or Closed.
   *****************************************************************************/
  $scope.status = function () {
    return mUI_Flags.isClosed
      ? 'CLOSED'
      : mUI_Flags.isPaid
        ? 'PAID'
        : mUI_Flags.isPartiallyPaid
          ? 'PARTIALLY PAID'
          : '';
  };

  /*****************************************************************************
   * startNewPO */
  /**
   * Loads a new PO object to manage.
   *****************************************************************************/
  function startNewPO() {
    mCurrentIdx = -1;
    FindPurchaseOrderDialog.reset();

    var defaults = {
      purchaseOrder: {
        entryDate: new Date(),
        entityID: null,
        authorizedBy: null,
        requestedBy: null,
        requiredDate: new Date(),
        items: [],
        notes: null
      },
      // This defaults to an empty object since its used like a dictionary/hash-map.
      entities: {},
      // Vendor must be null, the check is looking for vendor to exist so when it doesn't it skips the vendor sets.
      vendor: null
    };

    /**
     * Before we can start a new PO we always must know what the next number will be. We will this out for the customers
     * so they do not have to go back and look at what this value should be.
     * **/
    PurchaseOrdersService.getNextNumber().then((nextPoNumber) => {
      mNextPONumber = nextPoNumber;
      loadPO(defaults);
    });

    /*-----------------------*/
    /* Reset PO header info. */
    /*-----------------------*/
    mUI_Flags.isNew = true;
    mUI_Flags.isPaid = false;
    mUI_Flags.isClosed = false;

    /*-----------------------------------*/
    /* Scroll to the top of the page and */
    /* set focus on the For input field. */
    /*-----------------------------------*/
    $timeout(function () {
      document.querySelector('#ltFor').focus();
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    }, 200);
  }

  /***************************************************************************
   * validatePOItemTax */
  /**
   * Validates the item's tax rate is not set higher than 100%.
   *
   * @param  item  Item to validate.
   ***************************************************************************/
  $scope.validatePOItemTax = function (item) {
    if (item.subTotal < item.tax || item.taxRate > 1.0) {
      Alert.error(
        'Tax Rate has exceeded 100%.',
        'Tax Rate Invalid for ' + item.memo
      );
      return false;
    }

    return true;
  };

  /***************************************************************************
   * validatePOItemTotal */
  /**
   * Validates the purchaseOrderItem Total.
   ***************************************************************************/
  $scope.validatePOItemTotal = function (value) {
    /*-------------------------------------------------------*/
    /* If a non-inventory product was selected, and the      */
    /* total of the item will be less than $.01, Alert user. */
    /* We are not concerend with inventory products, because */
    /* values are handled by the Inventory Product dialog.   */
    /*-------------------------------------------------------*/
    if (
      $scope.data.purchaseOrderItem.isProduct &&
      !$scope.data.purchaseOrderItem.getSource().forInventory &&
      value <= 0
    ) {
      return 'Total must be above $0.00.';
    } else return null;
  };

  /*-----------------------------------------------*/
  /* Set up a watch for the For entity so that     */
  /* the mForVendorEntity reference can be updated */
  /*-----------------------------------------------*/
  $scope.$watch('data.forEntity', function (forEntity) {
    // If the vendor id is already the same as the forEntity then we've already set the vendor in loadPO so short-circuit.
    if (
      $scope.data.vendor &&
      $scope.data.forEntity &&
      $scope.data.forEntity.entity &&
      $scope.data.vendor.entity &&
      $scope.data.vendor.entity.id === $scope.data.forEntity.entity.id
    )
      return;

    const isEntityVendor =
      forEntity &&
      angular.isObject(forEntity) &&
      forEntity.entity.types.indexOf(SERVER.BooksDBConstants.ET_VENDOR) > -1;

    /*--------------------------------*/
    /* If the entity is a vendor, set */
    /* the vendor name and tax rate.  */
    /*--------------------------------*/
    if (isEntityVendor) {
      PurchaseOrdersService.findAddressVendors('', null, forEntity.entity.id)
        .then(function (resp) {
          // This request always gives back an array so we need to pull the 1st element out.
          const vendorInfo = resp[0];

          $scope.data.vendor = vendorInfo;
          mForVendorEntity = vendorInfo;
          $scope.data.purchaseOrderItem.taxRate = vendorInfo.entity.taxPercent;
        })
        .catch(function () {
          Alert.error(
            'Failed to find the matching vendor record that matches the assigned entity (For input). Try removing the for input and setting it again, if that does not work refresh your screen.',
            'Failure'
          );
        });
    } else {
      /*--------------------------------------*/
      /* If the entity is not a vendor, clear */
      /* the vendor input and tax percent.    */
      /*--------------------------------------*/
      mForVendorEntity = $scope.data.vendor = null;
      $scope.data.purchaseOrderItem.taxRate = null;
    }
  });

  /*--------------------------------------------------*/
  /* Watch for when the reviewOnly expression changes */
  /* so the delete column can be updated accordingly. */
  /*--------------------------------------------------*/
  $scope.$watch(
    function () {
      return $scope.reviewOnly();
    },
    function (value) {
      mDeleteCol.visible = !value;
    }
  );

  /*------------*/
  /* Listeners. */
  /*------------*/
  /*--------------------------------------------------------*/
  /* Set up listener for the delete row click event request */
  /*--------------------------------------------------------*/
  $scope.$on(
    CommonUIGridTemplates.EVENT_DELETE_ROW,
    function (event, grid, row) {
      /*------------------------------------------*/
      /* If the delete button is to be hidden, do */
      /* nothing as the item cannot be removed.   */
      /*------------------------------------------*/
      if (row.entity.hideDelete()) return;

      /*------------------------------------------------*/
      /* Otherwise remove the item and refresh the grid */
      /*------------------------------------------------*/
      var index = grid.options.data.indexOf(row.entity);
      grid.options.data.splice(index, 1);
      grid.api.core.refresh();
    }
  );

  /*----------------------------------*/
  /* Load the accounts, and products. */
  /*----------------------------------*/
  BusyScreen.setBusy(true);
  PurchaseOrdersService.getAccountsAndProducts().then(function (resp) {
    $scope.data.dpAccounts = resp.accounts;

    // Set this so getItems can load the items into the Item/Memo input.
    mPOItems = resp.poProducts;

    $scope.data.dpProducts = resp.products.sort(function (a, b) {
      return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
    });

    /**
     * Moved this within the .then of this service call so all the data is set before we start setting up a new PO.
     * **/
    startNewPO();
    BusyScreen.setBusy(false);
  });
}
